import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class EmptyRouterView extends Vue {
  protected setIdentified(status: boolean): void {
    this.$emit('identified', status);
  }

  protected openingDossier(): void {
    this.$emit('openingDossier');
  }

  protected logout(routeName: string): void {
    this.$emit('logout', routeName);
  }
}
